module.exports = __webpack_public_path__ + "static/media/inf_03pog30p.7356248d.mp3";